// frontend/src/pages/CustomerReviews.tsx
import React from 'react';

const CustomerReviews: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Reviews & Ratings</h1>
      <p>Your reviews and ratings for completed services.</p>
    </div>
  );
};

export default CustomerReviews;